import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import NetworkDetector from './components/NetworkStatus/NetworkDetector';

import MainLayout from './components/Layout/MainLayout';
import MatchesPage from './pages/MatchesPage';
import StatsPage from './pages/StatsPage';
import SettingsPage from './pages/SettingsPage';
import CreateMatchPage from './pages/CreateMatchPage';
import TeamConfigPage from './pages/TeamConfigPage';
import OpponentTeamConfigPage from './pages/OpponentTeamConfigPage';
import ConfigMatchPage from './pages/ConfigMatchPage';
import LiveMatchPage from './pages/LiveMatchPage';
import MatchDetailsPage from './pages/MatchDetailsPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import OnboardingPage from './pages/OnboardingPage';
import ProfilePage from './pages/ProfilePage';
import ProtectedRoute from './components/Auth/ProtectedRoute';

// Thème personnalisé pour Material UI
const theme = createTheme({
  palette: {
    primary: {
      main: '#1e3a8a', // Couleur principale de LiveMatch
    },
    secondary: {
      main: '#f59e0b',
    },
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <NetworkDetector />
          <Routes>
            {/* Routes publiques */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Routes protégées (nécessitent une authentification) */}
            <Route element={<ProtectedRoute />}>
              {/* Onboarding sans MainLayout */}
              <Route path="/onboarding" element={<OnboardingPage />} />
              <Route element={<MainLayout><Outlet /></MainLayout>}>
                <Route path="/" element={<MatchesPage />} />
                <Route path="/matchs" element={<MatchesPage />} />
                <Route path="/statistiques" element={<StatsPage />} />
                <Route path="/parametres" element={<SettingsPage />} />
                <Route path="/profil" element={<ProfilePage />} />
                <Route path="/creer-match" element={<CreateMatchPage />} />
                <Route path="/live-match/:matchId" element={<LiveMatchPage />} />
                <Route path="/match/:matchId" element={<MatchDetailsPage />} />
                <Route path="/config-equipe" element={<TeamConfigPage />} />
                <Route path="/config-equipe-adverse" element={<OpponentTeamConfigPage />} />
                <Route path="/config-match" element={<ConfigMatchPage />} />
              </Route>
            </Route>
            
            {/* Routes d'administration (nécessitent un rôle admin) */}
            <Route element={<ProtectedRoute requireAdmin={true} />}>
              <Route element={<MainLayout><Outlet /></MainLayout>}>
                <Route path="/admin" element={<AdminPage />} />
              </Route>
            </Route>
            
            {/* Redirection par défaut */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
